<template>
    <CieloLayout>
        <router-view />
    </CieloLayout>
</template>

<script>
const CieloLayout = () => import(
        /* webpackChunkName: "cielo-layout" */ '@/components/layout/CieloLayout'
);

export default {
  components: {
    CieloLayout,
  },


};
</script>

<style lang="scss" scoped>
.payment-type-title {
  color: #34454f;
  font-size: 16px;
  font-weight: 500;
}

.payment-type {
  border-radius: 8px;
  border: 1px solid #c5ced7;
  background: #ffffff;
  padding: 15px;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  height: 64px;
}

.payment-type-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  p {
    width: 60%;
    font-size: 16px;
    color: #231f20;
    margin: 0;
    flex: 1;
  }
}

.payment-type-img-wrapper {
  width: 50px;
  margin-right: 10px;
}

.loader {
  display: block;
  width: 70px;
  height: 70px;
}
</style>
